import { useContext } from 'react';
import { OptimizelyContext, useDecision } from '@optimizely/react-sdk';
import { NIGHTLY_RATES_CALENDAR_FLAG_KEY } from '../../experiment-registry';

export function useNightlyRatesCalendar(): { enabled: boolean } {
	const { optimizely } = useContext(OptimizelyContext);

	if (!optimizely) return { enabled: false };

	const [decision, clientReady] = useDecision(NIGHTLY_RATES_CALENDAR_FLAG_KEY, {
		autoUpdate: true,
	});
	return { enabled: clientReady && (decision?.enabled ?? false) };
}
